import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import { observer, inject } from 'mobx-react';
import CloseOneIcon from '../svg/CloseOneIcon';
import { formatPrice } from '@/utils/misc';
import { calculateCartTotals } from '@/utils/cartTotals';

const MinOrderModal = inject('wooCommerceStore', 'generalSettingsStore', 'studioStore')(observer(({ wooCommerceStore, generalSettingsStore, studioStore }) => {
  const t = useTranslations('Cart');
  const router = useRouter();

  // Don't show the modal if we're on the order-details page or during payment process
  if ((typeof window !== 'undefined' && (router.pathname.startsWith('/checkout') && localStorage.getItem('activeOrderDetails')))) {
    return null;
  }

  const container = studioStore.settings.product_popup?.container;
  const productInfoBackgroundColor = studioStore.settings.product_popup?.product_info_background_color;
  const primaryColor = studioStore.settings.colors.primary_color;

  let classes = "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl md:mx-auto max-h-[90vh] z-50";
  const style = {
    backgroundColor: productInfoBackgroundColor,
  };

  if (container === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, transparent 98%, ${productInfoBackgroundColor}),linear-gradient(${productInfoBackgroundColor} 0px, ${productInfoBackgroundColor} 0px)`;
    style.backgroundColor = '';
  } else {
    classes = classes + " rounded-lg shadow-lg p-4 bg-white";
  }

  const handleContinueShopping = () => {
    wooCommerceStore.toggleMinOrderModal();
    router.push('/');
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto" data-testid="min-order-modal">
      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <div className={classes} style={style}>
        <button
          className="absolute top-4 md:-top-8 left-4 md:-left-10 rtl:right-4 rtl:md:-right-10 rtl:left-auto z-10"
          onClick={() => wooCommerceStore.toggleMinOrderModal()}
        >
          <CloseOneIcon size="28px" stroke={primaryColor} />
        </button>

        <div className="max-h-[86vh] overflow-y-auto">
          <div className="p-3 md:p-6">
            <div className="px-4 md:px-12">
              <div className="text-center">
                <h2 className="mt-3 mb-6 text-2xl font-semibold text-primary-studio">
                  {t('minimum_order_required')}
                </h2>
                <p className="text-lg text-secondary-text-studio mb-4">
                  {t('minimum_order_message', {
                    amount: formatPrice(generalSettingsStore.minOrder, wooCommerceStore),
                  })}
                </p>
                <p className="text-lg text-secondary-text-studio mb-8">
                  {t('missing_amount_message', {
                    amount: formatPrice(
                      generalSettingsStore.minOrder - calculateCartTotals(wooCommerceStore.cart).total,
                      wooCommerceStore
                    ),
                  })}
                </p>
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent bg-primary px-8 py-3 text-base font-medium text-white shadow-sm hover:bg-primary-dark transition-colors duration-200"
                  onClick={handleContinueShopping}
                  style={{ backgroundColor: primaryColor, borderColor: primaryColor }}
                >
                  {t('continue_shopping')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}));

export default MinOrderModal;